import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { helperServices } from "../../shared/helper";
import { COMPONENT_TYPE_COMPONENT, COMPONENT_TYPE_NULL, COMPONENT_TYPE_PAGE } from '../../shared/constants';
import { UnauthorisedAcess } from './UnauthorisedAcess';

const ProtectedComponent = ({ componentName, component: Component, pageType, ...props }) => {
  const [hasAccess, setHasAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const access = helperServices.CheckAccessLevel(componentName);
        setHasAccess(access);
      } catch (error) {
        console.error('Access check failed:', error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [componentName]);

  if (loading) {
    return <div>Loading...</div>; // Or your loading component
  }

  if (COMPONENT_TYPE_NULL===pageType && !hasAccess) {
    return COMPONENT_TYPE_NULL;
  }
  
  if (COMPONENT_TYPE_PAGE===pageType && !hasAccess) {
    return <Redirect to="/access-denied" />;
  }
  
  if(COMPONENT_TYPE_COMPONENT===pageType && !hasAccess){    
    return <UnauthorisedAcess />;
  }

  return <Component {...props} />;
};

export default ProtectedComponent; 